globalThis.backoffice = globalThis.backoffice || {};

backoffice.Notifications = (function()
{
  function Notifications($container) {
    this.$container = $container;
    this.$content = $container.find('.notifications-content');
    this.refreshUrl = $container.data('refresh-source');

    this.events();
    this.poll();
  }

  Notifications.prototype = {
    events: function() {
      var self = this;

      self.$container.on('click', '.refresh-notifications', function() {
        self._refresh();
      });

      $('body').on('notifications.refresh', function() {
        self._refresh();
      });
    },
    poll: function() {
      var self = this;

      if(!backoffice.env.DEV) {
        setInterval(function() {
          self._refresh();
        }, 30000);
      }
    },
    _refresh: function() {
      var self = this;

      self.$content.block({
        message: '<i class="icon-spinner2 spinner"></i>',
        overlayCSS: {
          backgroundColor: '#fff',
          opacity: 0.8,
          cursor: 'wait'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'none'
        }
      });

      if(self.refreshUrl) {
        var activePaneId = self.$content.find('.tab-pane.active').attr('id');

        $.get(self.refreshUrl, { active_pane: activePaneId }, function(data) {
          if(data.response) {
            setTimeout(function() {


              self.$content.html(data.html).unblock();
            }, 500);
          }
        });
      }
    }
  }

  return Notifications;
})();
